
export default function Network() {
  const networkMembers = [
    { icon: 'ri-government-line', title: 'Administraciones', count: '50+' },
    { icon: 'ri-building-line', title: 'Empresas', count: '120+' },
    { icon: 'ri-team-line', title: 'Asociaciones', count: '80+' },
    { icon: 'ri-graduation-cap-line', title: 'Centros de conocimiento', count: '25+' }
  ];

  return (
    <section id="red-territorio360" className="py-20 bg-teal-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Una comunidad de personas que creen en el poder de la colaboración
          </h2>
          
          <p className="text-xl leading-relaxed max-w-4xl mx-auto mb-8">
            En <strong>Territorio360</strong> impulsamos una red abierta y participativa que une a administraciones, empresas, asociaciones, cooperativas y centros de conocimiento.
          </p>
          
          <blockquote className="text-2xl font-semibold bg-white/10 rounded-lg p-8 max-w-3xl mx-auto mb-8">
            Nuestra misión: <strong>convertir cada conexión en una oportunidad.</strong>
          </blockquote>
          
          <p className="text-lg leading-relaxed max-w-4xl mx-auto">
            La <strong>Red Territorio360</strong> es el espacio donde surgen proyectos, se comparten experiencias y se tejen alianzas para construir un futuro más innovador, justo y sostenible.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-16">
          {networkMembers.map((member, index) => (
            <div key={index} className="text-center text-white">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${member.icon} text-3xl`}></i>
              </div>
              <div className="text-3xl font-bold mb-2">{member.count}</div>
              <div className="text-lg">{member.title}</div>
            </div>
          ))}
        </div>

        <div className="relative">
          <img 
            src="https://readdy.ai/api/search-image?query=Network%20visualization%20with%20connected%20nodes%20representing%20rural%20innovation%20ecosystem%2C%20people%20silhouettes%20connected%20by%20glowing%20lines%2C%20modern%20digital%20network%20concept%2C%20teal%20and%20white%20color%20scheme%2C%20representing%20collaboration%20and%20connectivity%20in%20rural%20territories%2C%20professional%20and%20inspiring%20design&width=1200&height=600&seq=network-territorio360&orientation=landscape"
            alt="Red de colaboración Territorio360"
            className="w-full h-80 object-cover rounded-lg"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-teal-900/50 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
}
